module.exports = __webpack_public_path__ + "static/Testing-4f2196311008e39cc32045203a6e5b5d.svg";